export const COSMIFRAME_WALLET_ID = 'cosmiframe';
export const COSMIFRAME_KEYSTORECHANGE_EVENT = 'cosmiframe_keystorechange';
export const COSMIFRAME_NOT_CONNECTED_MESSAGE = 'Cosmiframe not connected.';
